module.exports = __webpack_public_path__ + "img/cszl-3.b270ed7c.png";